import TemplateModel from "./TemplateModel"
const EmailTemplateModel = new TemplateModel("email")
export default EmailTemplateModel